/**
 * Production contract for the licensed cat foreground service.
 * The service must return a transparent PNG/WebP and must not retain the
 * original image after the agreed processing window.
 */
import { apiFetch, apiUrl } from "./http";

export async function requestCatCutout(imageUrl: string, token: string): Promise<string> {
  const result = await apiFetch<{ imageUrl: string }>("/api/v1/images/cat-cutout", {
    method: "POST",
    headers: { "content-type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ imageUrl: imageUrl.replace(/^https?:\/\/[^/]+/, "") }),
  }, 30000);
  return apiUrl(result.imageUrl);
}

export async function uploadImage(file: File, token: string): Promise<string> {
  if (!file.type.startsWith("image/")) throw new Error("image-required");
  if (file.size > 10 * 1024 * 1024) throw new Error("image-too-large");
  const body = new FormData();
  body.append("image", file);
  const response = await apiFetch<{ imageUrl: string }>("/api/v1/uploads/images", {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body,
  }, 30000);
  return apiUrl(response.imageUrl);
}

export async function classifyAnimal(imageUrl: string, token: string): Promise<{ species: "cat" | "dog" | "unknown"; confidence: number }> {
  const response = await apiFetch<{ species: "cat" | "dog" | "unknown"; confidence: number }>("/api/v1/images/classify-animal", {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: JSON.stringify({ imageUrl: imageUrl.replace(/^https?:\/\/[^/]+/, "") }),
  }, 15000);
  return response;
}

export async function analyzeAnimal(imageUrl: string, token: string) {
  return apiFetch<{ species: "cat" | "dog"; coat: string; feature: string; observation: string }>("/api/v1/images/analyze-animal", {
    method: "POST", headers: { "content-type": "application/json", Authorization: `Bearer ${token}` }, body: JSON.stringify({ imageUrl: imageUrl.replace(/^https?:\/\/[^/]+/, "") }),
  }, 50000);
}
